import { Injectable } from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';
import {catchError} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class EnableSuppresNotificationsService extends  DataService {
  private baseURI = this.apiUri + '/suppress-notifications/';


  constructor(http: HttpClient) {
    super(http);
    this.setUri(this.baseURI);
  }

  updateSuppressNotifications(userId, paylaod) {
    return this.http.put(this.baseURI + userId, paylaod, {responseType: 'text'}).pipe(catchError(this.handleError));
  }

  getAllSuppressNotifications() {
    return this.http.get(this.baseURI + 'getall');
  }
}
